// Central place for company contact info + Google Maps embed url.
export const COMPANY = {
  name: "2TProd Studios Inc.",
  address1: "210b 6e Avenue",
  address2: "L'Île-Perrot, QC J7V 4V4",
  country: "Canada",
  phone: "+1 514-316-8271",
  phoneHref: "tel:+15143168271",
  email: "hello@2tprodstudios.com",
  emailHref: "mailto:hello@2tprodstudios.com",
  mapQuery: "210b 6e Avenue, L'Île-Perrot, QC J7V 4V4, Canada",
  mapEmbed:
    "https://www.google.com/maps?q=210b%206e%20Avenue%2C%20L%27%C3%8Ele-Perrot%2C%20QC%20J7V%204V4&output=embed",
  mapLink:
    "https://www.google.com/maps/search/?api=1&query=210b%206e%20Avenue%2C%20L%27%C3%8Ele-Perrot%2C%20QC%20J7V%204V4",
  socials: [
    { label: "Instagram", href: "https://instagram.com/2tprodstudios" },
    { label: "Facebook", href: "https://facebook.com/2tprodstudios" },
    { label: "LinkedIn", href: "https://linkedin.com/company/2tprodstudios" },
  ],
};
